export interface PoleEmploiContract {
  code: string;
  typeNature?: boolean;
  libelle: string;
}

export enum ContractsEnum {
  CDI = 'CDI',
  CDD = 'CDD',
  SAI = 'SAI',
  MIS = 'MIS',
}

export const PoleEmploiContractMapping: Record<ContractsEnum, string> = {
  [ContractsEnum.CDI]: 'CDI',
  [ContractsEnum.CDD]: 'CDD',
  // CDS: 'CDD sénior',
  [ContractsEnum.MIS]: 'Mission intérimaire',
  [ContractsEnum.SAI]: 'Saisonnier',
  // CCE: 'Profession commerciale',
  // FRA: 'Franchise',
  // LIB: 'Profession libérale',
  // REP: "Reprise d'entreprise",
  // TTI: 'CTTI',
  // DDI: 'CDD insertion',
  // DIN: 'CDI Intérimaire',
};

export enum SummerContractsEnum {
  CDD = 'CDD',
  SAI = 'SAI',
  MIS = 'MIS',
}

export const SummerJobsPoleEmploiContractMapping: Record<SummerContractsEnum, string> = {
  [ContractsEnum.CDD]: 'CDD',
  [ContractsEnum.MIS]: 'Mission intérimaire',
  [ContractsEnum.SAI]: 'Saisonnier',
};

export const PoleEmploiNatureContrat: Record<string, string> = {
  E1: 'Contrat travail',
  E2: "Contrat d'apprentissage",
  FA: 'Act. Formation pré.recrut.',
  FJ: 'Contrat pacte',
  FS: 'Contrat de professionnalisation',
  FT: 'CUI - CAE',
  FU: 'CUI - CIE',
  I1: "Insertion par l'activ.éco.",
  NS: 'Emploi non salarié',
  FV: 'Prépa.opérationnel.emploi',
  FW: 'Emploi Avenir non marchand',
  FX: 'Emploi Avenir marchand',
  FY: 'Emploi Avenir Professeur',
  PS: 'Portage salarial',
  PR: 'Contrat PrAB',
  CC: "CDI de chantier ou d'opération",
  CU: "Contrat d'usage",
  EE: "Contrat d'Engagement Educatif",
  ER: 'Engagement à servir dans la réserve',
  CI: 'Contrat intermittent',
};
